import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const fadeInUpVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
  exit: { opacity: 0, y: -30, transition: { duration: 0.4, ease: "easeIn" } },
};

const AboutPage = ({ isActive }) => {
  return (
    <div className="page work-page">
      <div className="stars"></div>
      <div className="stars2"></div>
      <div className="stars3"></div>

      <AnimatePresence>
        {isActive && (
          <motion.div
            className="work-content"
            key="work-content"
            variants={fadeInUpVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <h2>WORK EXPERIENCE</h2>
            <div className="work-cards">
              <div className="work-card">
                <div className="work-card-header">
                  <span className="work-role">Software Engineer</span>
                  <div className="work-location-group">
                    <span className="work-company">@ Mühlbauer</span>
                    <span className="work-location">— Roding, Germany</span>
                  </div>
                </div>
                <div className="work-card-details">
                  <span className="work-duration">Sep 2024 – Present</span>
                  <p>
                    At Mühlbauer, I work on developing and maintaining software
                    solutions for card personalization and production systems,
                    while closely collaborating with machine operators to
                    integrate, troubleshoot, and optimize the performance of
                    card machines to ensure smooth and efficient operations.
                  </p>
                </div>
              </div>
              <div className="work-card">
                <div className="work-card-header">
                  <span className="work-role">App Developer Intern</span>
                  <div className="work-location-group">
                    <span className="work-company">
                      @ Daimler Truck Innovation Center India
                    </span>
                    <span className="work-location">— Bengaluru, India</span>
                  </div>
                </div>
                <div className="work-card-details">
                  <span className="work-duration">Feb 2024 – Jul 2024</span>
                  <p>
                    At Daimler Trucks, I got the opportunity to work on
                    developing critical user interfaces and understanding the
                    overall architecture of the Daimler Trucks' application
                    platform, enhancing my skills in app development and user
                    interface design.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AboutPage;
